import { useState } from "react"
import {BsArrowLeftCircle, BsArrowRightCircle} from 'react-icons/bs'
import {LiaWindowClose} from 'react-icons/lia'
import { useCases } from "../data"
import {Link} from 'react-router-dom'

import { Navigation, Pagination } from 'swiper/modules';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const UseCases = () => {
    
    const [isMovieShowing, setIsMovieShowing] = useState(false);
    const [Movie, setMovie] = useState(null);
    const [MWidth, setMWidth] = useState(0);
    const [MHeight, setMHeight] = useState(0);

    /*=============== SHOW DROPDOWN MENU ===============*/
    const movieEvent = (path, mwidth, mheight) => {

        if (!isMovieShowing) {
            const movie__item = document.querySelector('.useCase__movie__item')

            setMWidth(mwidth)
            setMHeight(mheight)
            toggleItem(movie__item, path)
        }
    }

    const toggleItem = (item, path) => {

        const movieWrapper = item.querySelector('.useCase__movie__wrapper')

        if(item.classList.contains('useCase__show-movie-item')) {

            item.classList.remove('useCase__show-movie-item')
            movieWrapper.classList.remove('useCase__show-movie__wrapper')
            item.classList.add('useCase__hide-movie-item')
            movieWrapper.classList.add('useCase__hide-movie__wrapper')

            setIsMovieShowing(false)

            setMovie(null)

        } else {

            if(item.classList.contains('useCase__hide-movie-item')) {

                item.classList.remove('useCase__hide-movie-item')
            }

            item.classList.add('useCase__show-movie-item')

            if(movieWrapper.classList.contains('useCase__hide-movie__wrapper')) {

                movieWrapper.classList.remove('useCase__hide-movie__wrapper')
            }

            setMovie(path)

            movieWrapper.classList.add('useCase__show-movie__wrapper')

            setIsMovieShowing(true)
        }
    }

    const closeMenu = () => {

        const showMovie = document.querySelector('.useCase__show-movie-item')

        if(showMovie) {
            toggleItem(showMovie)
        }
    }



  return (
    <section className="useCases">
        <Swiper className="useCases__container"
              modules={[Navigation, Pagination]}
              spaceBetween={10}
              slidesPerView={1}
              navigation={{ clickable: true }}
              pagination={{ clickable: true }}
        >
            {
                useCases.map(({categary, title, description, movie, image, mwidth, mheight, projectlink}, index) => {
                    return (
                        <SwiperSlide className="useCases_card" style={{backgroundImage: `url(${image})`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat'}} key={index} >
                            <div className="useCases-content-container" >
                                <button className="useCases__btn" ><BsArrowLeftCircle className="useCases__arrow"/></button>
                                <div className="useCases-center-content">
                                    <p>USECASES</p>
                                    <h2>PROJECTS</h2>
                                    <p>{categary}</p>
                                    <h3>{title}</h3>
                                    <p>{description}</p>
                                    <a className='trans_btn md' onClick={() => movieEvent(movie, mwidth, mheight)}>WATCH CASE</a>
                                    <div className="useCases__More_btn-container">
                                        <Link to={projectlink} className='white_btn lg'>MORE PROJECTS</Link>
                                    </div>
                                </div>
                                <button className="useCases__btn" ><BsArrowRightCircle className="useCases__arrow"/></button>
                            </div>
                            {/* <div className="useCases__container-bg">
                                <img className="" src={image} alt={title} />
                            </div> */}
                        </SwiperSlide> 
                    )
                }) 
            }
        </Swiper>

        <div className='useCase__movie__item' onClick={() => closeMenu()}>
            <div className='useCase__movie__container'>
                <div className='useCase__movie__inner-container'>
                    <div className='useCase__movie__wrapper'>
                        <LiaWindowClose className='useCase__video-close-btn' />
                        <iframe className='useCase__video-iframe' width={MWidth} height={MHeight} src={Movie} type="video/mp4" frameBorder='0' autoPlay encrypted-media gyroscope controls></iframe>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default UseCases


